import { VideoPlayerContainer } from '@zoom/videosdk';

/**
 * Zoom公式の例
 * https://developers.zoom.us/docs/video-sdk/web/video/#start-video
 *
 * MDNのPiPサンプル
 * https://github.com/mdn/dom-examples/blob/main/document-picture-in-picture/main.js
 *
 * Reactの例もあるが、一旦適用していない
 * https://hackernoon.com/how-to-document-picture-in-picture-in-react-with-typescript
 */
export let pipWindow: Window | undefined;
export const enterPictureInPicture = async (videoContainerWrapper: HTMLDivElement, message: string) => {
  if (window.document.pictureInPictureEnabled && 'documentPictureInPicture' in window) {
    try {
      pipWindow = await (window.documentPictureInPicture as any).requestWindow();
      // Insert a stub after the container has been transferred to the PipWindow.
      const placeholder = document.createElement('div');
      placeholder.setAttribute(
        'style',
        'color: white;display: flex;' +
          'height: 100%;' +
          'margin: auto;' +
          'text-align: center;' +
          'justify-content: center;' +
          'align-items: center;'
      );

      placeholder.textContent = message;
      placeholder.id = 'PiP-placeholder';
      const videoContainer = videoContainerWrapper.querySelector('video-player-container');
      if (videoContainer) {
        // Ensure styles are applied
        // Array.from(document.styleSheets).forEach((styleSheet) => {
        //   Array.from(styleSheet.cssRules).forEach((rule) => {
        //     const style = document.createElement('style');
        //     style.textContent = rule.cssText;
        //     pipWindow!.document.head.appendChild(style);
        //   });
        // });
        const style = document.createElement('style');
        style.textContent =
          'body {background: black;}' +
          'p {color: white; padding: 10px}' +
          'ul {padding: 0}' +
          '.video-player {height:150px}' +
          `
          .avatar {
            color: white;
          }
          `;
        pipWindow!.document.head.appendChild(style);

        videoContainer.setAttribute('style', 'display: grid;');
        // Move the video container into the PiP window
        videoContainer.parentNode?.insertBefore(placeholder, videoContainer);
        pipWindow!.document.body.appendChild(videoContainer);
        // pipWindow!.document.body.setAttribute('style', 'background: black;');
      }
      pipWindow!.addEventListener('pagehide', (e: Event) => {
        console.log(videoContainer);
        const v = pipWindow!.document.querySelector('video-player-container');
        if (!v) {
          return;
        }
        leavePictureInPicture(v as VideoPlayerContainer);
      });
    } catch (error) {
      console.error('Failed to enter Picture-in-Picture mode:', error);
    }
  } else {
    console.warn('Picture-in-Picture is not supported by your browser.');
  }
};
export const leavePictureInPicture = async (videoContainer: VideoPlayerContainer) => {
  const placeholder = document.getElementById('PiP-placeholder');
  try {
    if (placeholder && videoContainer) {
      placeholder.parentNode?.replaceChild(videoContainer, placeholder);
      await pipWindow!.close();
      pipWindow = undefined;
    }
  } catch (error) {
    console.error('Failed to leave Picture-in-Picture mode:', error);
  }
};
